import * as basicLightbox from 'basiclightbox'
import 'basiclightbox/dist/basiclightbox.min.css'
import Swiper, { Autoplay, Pagination } from 'swiper'
import 'swiper/css'
import 'swiper/css/pagination'
import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger.js"
import AOS from 'aos'
import 'aos/dist/aos.css'
AOS.init()
gsap.registerPlugin( ScrollTrigger )

const instance = basicLightbox.create(
    document.querySelector('template')
)

const appBtn = document.querySelector('[lightbox-app]')
if( appBtn ) {
    appBtn.addEventListener("click", (e)=> {
        e.preventDefault()
        instance.show()

        document.addEventListener("click", function(e){
            const close = e.target.closest('[lightbox-close]')
            if( close ){
                e.preventDefault()
                instance.close()
            }
        })
    })
}

const tootlgBtn = document.querySelector('[data-toggle]')
tootlgBtn.addEventListener("click", (e)=> {
    e.preventDefault()
    tootlgBtn.classList.toggle('open')
    const h = document.querySelector('header .brand')
    const n = document.querySelector('header nav')
    const f = document.querySelector('footer')
    h.classList.toggle('open')
    n.classList.toggle('open')
    f.classList.toggle('open')
})


// toggle
const toggleBoxs = document.querySelectorAll('[data-toggleBox]')
toggleBoxs.forEach( (toggleBox) => {
    toggleBox.addEventListener("click", function(e){
        e.preventDefault()
        this.classList.toggle('open')
        this.nextElementSibling.style.display = (this.classList.contains('open')) ? 'block' : 'none'
    })
})

// pc 選單
const navItems = document.querySelectorAll("header nav>ul>li")
if(document.querySelector("body").offsetWidth >= 1024) {
    navItems.forEach( (navItem) => {
        let t = .45
        let defaultSet = {display: 'none', y: -20, opacity: 0, duration: t}
        gsap.set(navItem.children[1], defaultSet)
        
        navItem.addEventListener( "mouseenter", function(e){
            gsap.to(navItem.children[1], {display: 'block', y: 0, opacity: 1, duration: t})
        })
        navItem.addEventListener( "mouseleave", function(e){
            gsap.to(navItem.children[1], defaultSet)
        })
    })
}

// 首頁banner

// var tag = document.createElement('script')
// tag.src = "https://www.youtube.com/iframe_api"
// var firstScriptTag = document.getElementsByTagName('script')[0]
// firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)
// var player
// function yt_init(ytMovs) {
//     let ytID = ytMovs[ Math.floor( Math.random() * ytMovs.length) ]
//     player = new YT.Player("ytplayer", {
//         height: 'auto',
//         width: 'auto',
//         videoId: ytID,
//         playerVars: {
//             'autoplay': 1,
//             'controls': 0,
//             'loop': 1,
//             'rel': 0,
//             'modestbranding': 1,
//         },
//         events: {
//             'onReady': onPlayerReady,
//             'onStateChange': onPlayerStateChange
//         }
//     })

//     function onPlayerReady(event) {
//         player.mute()
//         player.playVideo()
//     }

//     function onPlayerStateChange(s) {
//         if(s.data === 0) {
//             player.mute()
//             player.playVideo()
//         }
//     }
// }

// var ytMovs = ['L2ZX-xq3U8k','DAXva82MxIo']
var ytMovs = ['index01.mp4','index02.mp4']

var swiper = new Swiper('.swiper1', {
    modules: [Autoplay, Pagination],
    loop: true,
    speed: 1000,
    pagination: {
        el: '.swiper-pagination',
        type: 'bullets'
    },
    on: {
        afterInit: function(){
            let ytID = './assets/mov/'+ytMovs[ Math.floor( Math.random() * ytMovs.length) ]
            let vid = document.getElementById("myVideo")
            vid.src = ytID
            // let checkYT = setInterval(function() {
            //     yt_init(ytMovs) // 隨機取一個
            //     clearInterval(checkYT);
            // }, 100)
        },
        slideChangeTransitionStart: function(){
            // let o = this.slides[this.activeIndex].querySelector('.ytplayer')
            
            // if(o) {
            //     player.mute()
            //     player.playVideo()
            // } else {
            //     player.stopVideo()
            //     player.clearVideo()
            // }
        }
    },
    autoplay: {
        delay: 4000,
        // pauseOnMouseEnter: true
    },
})


const swiper2 = new Swiper('.swiper2', {
    slidesPerView: 2,
    spaceBetween: 40,
    centeredSlides: true,
    breakpoints: {
        // when window width is >= 1024
        1024: {
            enabled: false,
            centeredSlides: false,
            slidesPerView: 3,
            spaceBetween: '4.8718%'
        }
    }
})



// contact
const addressToggle = document.querySelectorAll('.contact-list>div h4')
addressToggle.forEach( (obj) => {
    obj.addEventListener("click", function(e){
        e.preventDefault()
        this.classList.toggle('open')
        this.nextElementSibling.style.display = (this.classList.contains('open')) ? 'block' : 'none'
    })
})

// 合作工程
const photoToggle = document.querySelectorAll('.photo-toggle')
photoToggle.forEach( (obj) => {
    obj.addEventListener("click", function(e){
        e.preventDefault()
        this.classList.toggle('open')
        const b = this.nextElementSibling
        const s = b.nextElementSibling
        b.style.display = (this.classList.contains('open')) ? 'block' : 'none'
        s.style.display = (this.classList.contains('open')) ? 'block' : 'none'
    })
})

// tabs
const tabsBtns = document.querySelectorAll('.tabs-nav li>a')
const tabContents = document.querySelectorAll('.product-section>div')
if( tabsBtns.length > 0 && tabsBtns.length === tabContents.length ) {
    tabsBtns[0].classList.add("is-active")
    tabContents[0].style.display = 'block'
    tabsBtns.forEach( (btn) => {
        btn.addEventListener("click", function(e){
            e.preventDefault()
            tabsBtns.forEach( (btn) => {
                btn.classList.remove("is-active")
            })
            this.classList.add("is-active")
            tabContents.forEach( (contnet) => {
                contnet.style.display = 'none'
            })
            const id = this.getAttribute('href')
            let showID = document.getElementById(id.substring(1))
            showID.style.display = 'block'
            gsap.from(showID, {
                opacity: 0,
                y: 60,
                duration: .87,
                ease: "power2.out"
            })
        })
    })
}

const h1Title = document.querySelector("h1.page-section + div > div")
if( h1Title ) {
    gsap.to(h1Title, {
        scrollTrigger: {
            trigger: h1Title,
            start: "top top", // when the top of the trigger hits the top of the viewport
            end: "+=500",
            scrub: 1,
            markers: false
        },
        backgroundPositionY: "150px",
    })    
}

const photos = document.querySelectorAll(".photo-box:not(.page-bottom), .bg-photo:not(.page-bottom)")
if(photos.length > 0) {
    photos.forEach( (photo) => {
        gsap.fromTo(photo, {
            y: 60,
            opacity: 0
        }, {
            y: 0,
            opacity: 1,
            scrollTrigger: {
                trigger: photo,
                start: "top bottom-="+(photo.offsetHeight/8), // when the top of the trigger hits the top of the viewport
                end: "+="+(photo.offsetHeight/2),
                scrub: 1,
                markers: false
            }
        })
    })
}



const greenTop = document.querySelector('.green-top')
const greenTopH1 = document.querySelector('.green-top h1')
if(greenTop) {

    gsap.to(greenTop, {
        backgroundPosition: "0 "+(greenTop.offsetHeight/8)+"px",
        scrollTrigger: {
            trigger: greenTop,
            start: "+=120 top", // when the top of the trigger hits the top of the viewport
            end: "bottom",
            scrub: 1,
            markers: false
        }
    })
    
}


const bottomElem = document.querySelector('.page-bottom')
if(bottomElem) {
    function animateBottom(elem) {
        gsap.fromTo(".page-bottom", {
            opacity: 0,
            backgroundSize: "118% 118%",
        }, {
            opacity: 1,
            backgroundSize: "cover",
            duration: 2,
        })    
    }
    
    function hide(elem) {
        gsap.set(elem, {autoAlpha: 0});
    }

    ScrollTrigger.create({
        trigger: bottomElem,
        markers: false,
        onEnter: ()=>{
            animateBottom(bottomElem)
        },
        onLeave: ()=>{
            hide(bottomElem)
         }
    })
    
}

const tabnavBtn = document.querySelector('[href="#tabnav"]')
if(tabnavBtn) {
    tabnavBtn.addEventListener("click", function(e){
        e.preventDefault()
        let t = document.getElementById("tabnav").offsetTop - 140
        
        window.scrollTo({
            behavior: 'smooth',
            top: t
        })
        // document.getElementById("tabnav").scrollIntoView({
        //     top: offsetPosition,
        //     behavior: 'smooth'
        // })
    })
}
